import { FC, useState } from 'react';
import ReactDOM from 'react-dom';
import { useMembersStore } from '../../../MembersProvider';
import { IPageStatus } from '../../../type';
import styled from './index.module.scss';
import SubIcon from './Icon';
import ShopCardIcon from './ShopCardIcon';
import CheckedIcon from '@/components/MembersDay/FY2024/Teaser/Subscribe/Icon';
import useConfig from '@/components/MembersDay/FY2025/Sections/Subscribe/useConfig';
import Emarsys from '@/components/MembersDay/FY2025/Sections/Emarsys';
import { EU_SITES, euEmailSource, currentEmailSource, finishedSource } from '@/constants/membersday';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { getPrivacyPolicy } from '@/utils/common';

const hasCheckBoxLocal = ['au'].concat(EU_SITES);

interface IProps {
    type?: string;
    isShowIcon?: boolean; // 是否显示icon, 产品在第二次会员节上线要下线这个入口，不管有没活动结束
}

const source = 'Y25_ECO_CREDITS_DAY';
const SUPPORTED_LOCALES = ['us', 'ca', 'jp', 'au', 'kr', 'za'];

const BuoySubscribe: FC<IProps> = ({ isShowIcon = true }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.subscribe');
    const { contactListId, fields } = useConfig(locale);
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(SUPPORTED_LOCALES.includes(locale) ? true : false);
    const { pageStatus } = useMembersStore();

    const shopNowUrl: Record<string, string> = {
        za: 'https://za.ecoflow.com/pages/easter-members-festival',
        au: 'https://au.ecoflow.com/pages/easter-day-campaign',
    };

    const handleNextPage = () => {
        gtm.push({ event: 'uaEvent', event_name: 'buy', product_name: 'none', position: 'Members-Festival_floating icon' });
        window.open(shopNowUrl[locale] || `https://${locale}.ecoflow.com/pages/members-festival`, '_blank');
    };

    const successCallBack = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('buoy_pop_btn'),
            status: 'success',
            tag: 'Agree',
        });
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('buoy_pop_btn'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    const Modal = () => {
        return ReactDOM.createPortal(
            <div className={`glo-editor-modal glo-editor-modal-show ${styled.BuoySubPop}`}>
                <div className="glo-editor-modal-wrap">
                    <div className="modal-content">
                        <div className="close" onClick={() => setOpen(false)}>
                            x
                        </div>
                        <h6 className="title">{pageStatus === IPageStatus.END && t('buoy_pop_title_end') ? t('buoy_pop_title_end') : t('buoy_pop_title')}</h6>
                        <p className="desc">{t('buoy_pop_desc')}</p>
                        <div className="email">
                            <Emarsys
                                contactListId={contactListId}
                                fields={fields}
                                source={source}
                                submitText={t('buoy_pop_btn')}
                                placeholder={t('buoy_pop_placeholder')}
                                successCallback={successCallBack}
                                errorCallback={errorCallback}
                                // disabled={hasCheckBoxLocal.includes(locale) && !checked}
                                checked={checked}
                            />
                            {/* {success && <p className="success">{t('buoy_pop_success')}</p>} */}
                        </div>
                        <p className="protocol">
                            <span className={`check ${checked && 'checked'}`} onClick={() => setChecked(!checked)}>
                                {checked && <CheckedIcon />}
                            </span>
                            {t.rich('protocol', {
                                line1: (text: string) => {
                                    const defaultUrl = getPrivacyPolicy(locale);
                                    const linkMap: Record<string, string> = {
                                        jp: 'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html',
                                    };
                                    const link = linkMap[locale] ? linkMap[locale] : defaultUrl;
                                    return (
                                        <a className="link" href={link} target="_blank" rel="noreferrer">
                                            {text}
                                        </a>
                                    );
                                },
                                line2: (text: string) => {
                                    const defaultUrl = `https://${locale}.ecoflow.com/policies/terms-of-service`;
                                    const linkMap: Record<string, string> = {
                                        jp: 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html',
                                    };
                                    const link = linkMap[locale] ? linkMap[locale] : defaultUrl;
                                    return (
                                        <a className="link" href={link} target="_blank" rel="noreferrer">
                                            {text}
                                        </a>
                                    );
                                },
                            })}
                        </p>
                    </div>
                </div>
            </div>,
            document.body,
        );
    };

    return (
        <>
            {/* <div className={`${styled.subscribeIcon} ${isEnter1 ? '' : ' subscribeIcon-hide'}`}> */}
            <div className={`${styled.subscribeIcon}`}>
                {pageStatus === IPageStatus.ACTIVITY && isShowIcon && (
                    <div className="shopcard-icon" onClick={handleNextPage}>
                        <ShopCardIcon />
                    </div>
                )}
                <div
                    className="wrapper"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'floating_button',
                            button_name: t('buoy_icon'),
                        });
                        setOpen(true);
                    }}
                >
                    <SubIcon />
                    <span className="subscribeIcon-text">{t('buoy_icon')}</span>
                </div>
            </div>
            {open && <Modal />}
        </>
    );
};

export default BuoySubscribe;
